import { isPlatformBrowser } from '@angular/common';
import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { initFlowbite } from 'flowbite';
import { RouterModule } from '@angular/router';
import { ExternalSvgModule } from '@ui-lib';

@Component({
  selector: 'directory-portal-root',
  templateUrl: './app.component.html',
  imports: [RouterModule, ExternalSvgModule],
})
export class AppComponent implements OnInit {
  private readonly platformId = inject(PLATFORM_ID);

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      initFlowbite();
    }
  }
}
